import { createAction, props } from '@ngrx/store';
import { Webshop } from '@models/webshop.model';

export enum WebshopActions {
  GET_WEBSHOPS = '[Webshops] Get webshops',
  GET_WEBSHOPS_SUCCESS = '[Webshops] Webshops fetched',
  GET_WEBSHOPS_FAILED = '[Webshops] Cannot fetch webshops',
  GET_WEBSHOP = '[Webshops] Get webshop',
  GET_WEBSHOP_SUCCESS = '[Webshops] Webshop fetched',
  GET_WEBSHOP_FAILED = '[Webshops] Cannot fetch webshop',
  CREATE_WEBSHOP = '[Webshops] Create webshop',
  CREATE_WEBSHOP_SUCCESS = '[Webshops] Webshop created',
  CREATE_WEBSHOP_FAILED = '[Webshops] Cannot create webshop',
  UPDATE_WEBSHOP = '[Webshops] Update webshop',
  UPDATE_WEBSHOP_SUCCESS = '[Webshops] Webshop updated',
  UPDATE_WEBSHOP_FAILED = '[Webshops] Cannot update webshop',
  DELETE_WEBSHOP = '[Webshops] Delete webshop',
  DELETE_WEBSHOP_SUCCESS = '[Webshops] Webshop deleted',
  DELETE_WEBSHOP_FAILED = '[Webshops] Cannot delete webshop',
  SELECT_WEBSHOP = '[Webshops] Select webshop',
}

export const fetchWebshops = createAction(WebshopActions.GET_WEBSHOPS);
export const webshopsFetched = createAction(WebshopActions.GET_WEBSHOPS_SUCCESS, props<{ payload: Webshop[] }>());
export const cannotFetchWebshops = createAction(WebshopActions.GET_WEBSHOPS_FAILED, props<{ error: string }>());
export const fetchWebshop = createAction(WebshopActions.GET_WEBSHOP, props<{ payload: string }>());
export const webshopFetched = createAction(WebshopActions.GET_WEBSHOP_SUCCESS, props<{ payload: Webshop }>());
export const cannotFetchWebshop = createAction(WebshopActions.GET_WEBSHOP_FAILED, props<{ error: string }>());
export const createWebshop = createAction(WebshopActions.CREATE_WEBSHOP, props<{ payload: Webshop }>());
export const webshopCreated = createAction(WebshopActions.CREATE_WEBSHOP_SUCCESS, props<{ payload: Webshop }>());
export const cannotCreateWebshop = createAction(WebshopActions.CREATE_WEBSHOP_FAILED, props<{ error: string }>());
export const updateWebshop = createAction(WebshopActions.UPDATE_WEBSHOP, props<{ payload: Webshop }>());
export const webshopUpdated = createAction(WebshopActions.UPDATE_WEBSHOP_SUCCESS, props<{ payload: Webshop }>());
export const cannotUpdateWebshop = createAction(WebshopActions.UPDATE_WEBSHOP_FAILED, props<{ error: string }>());
export const deleteWebshop = createAction(WebshopActions.DELETE_WEBSHOP, props<{ payload: string }>());
export const webshopDeleted = createAction(WebshopActions.DELETE_WEBSHOP_SUCCESS, props<{ payload: string }>());
export const cannotDeleteWebshop = createAction(WebshopActions.DELETE_WEBSHOP_FAILED, props<{ error: string }>());

export const selectWebshop = createAction(WebshopActions.SELECT_WEBSHOP, props<{ payload: string | null }>());
